import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function PhilosophicalFoundation() {
  return <SectionWrapper hasDivider glowPosition="none" className="bg-white/[0.01]" data-id="element-147">
      <div className="max-w-4xl mx-auto text-center" data-id="element-148">
        <div className="flex justify-center mb-8" data-id="element-149">
          <div className="w-16 h-16 rounded-full bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-150">
            <BookOpenIcon className="w-8 h-8 text-slate-300" data-id="element-151" />
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-8 font-serif" data-id="element-152">
          From philosopher-kings to self-mastery
        </h2>

        <div className="w-24 h-px bg-gradient-to-r from-transparent via-slate-500 to-transparent mx-auto mb-8" data-id="element-153" />

        <p className="text-xl md:text-2xl text-slate-300 leading-relaxed font-light" data-id="element-154">
          Philosophically, the model draws from traditions associated with
          Plato's philosopher-king and Nietzsche's ideal of self-overcoming and
          self-mastery. Its claim is that the next serious political order
          cannot remain merely democratic, technocratic, or managerial.
        </p>
        <p className="text-xl md:text-2xl text-slate-300 leading-relaxed font-light mt-6" data-id="element-155">
          It must become{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-400 font-medium" data-id="element-156">
            cognarchic
          </span>
          : organized around the cultivation, assessment, and protection of
          sound judgment as a foundational public good.
        </p>
      </div>
    </SectionWrapper>;
}